import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useCallback
} from 'react';
import { v4 as uuid } from 'uuid';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { unset, set } from 'lodash';
import { findPath, formatPath, loopTreeData, validateNode } from './helpers';
import FlexChatIntegration from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration';

const context_format = {
  removeNode: () => {},
  treeData: {},
  isModalOpen: false,
  setIsModalOpen: () => {},
  openModal: () => {},
  selectedNode: {},
  createNewLevel: () => {},
  onSubmitModalData: () => {},
  setTypeNodeAction: () => {},
  typeNodeAction: () => {},
  submitDataToBackend: () => {},
  resetTree: () => {},
  availableActions: [],
  availableQueues: [],
  setAvailableActions: () => {},
  setAvailableQueues: () => {}
};

const defaultTreeData = {
  0: {
    nodeId: uuid(),
    level: 1,
    nodeQueue: undefined,
    mac: {
      level: null,
      idMac: null
    },
    action: {},
    nodes: {},
    isDefault: true,
    hasVariable: false,
    variables: [],
    hasIntegration: false,
    params: [],
    integrationFunctionName: ''
  }
};

const DialogTreeContext = createContext(context_format);

export function DialogTreeProvider({ children }) {
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [availableActions, setAvailableActions] = useState([]);
  const [availableQueues, setAvailableQueues] = useState([]);
  const [treeData, setTreeData] = useState(defaultTreeData);
  const [selectedNode, setSelectedNode] = useState({});
  const [linkedNodeId, setLinkedNodeId] = useState();

  const [typeNodeAction, setTypeNodeAction] = useState('');
  const actualLevelAvailableLevels = treeData ? Object.keys(treeData) : [];
  const [nodeActions, setNodeActions] = useState([]);

  const defaultNode = {
    nodeId: uuid(),
    level: selectedNode.level + 1,
    nodeQueue: undefined,
    mac: {
      level: null,
      idMac: null
    },
    action: {},
    nodes: {},
    isDefault: true,
    hasVariable: false,
    variables: [],
    hasIntegration: false,
    params: [],
    integrationFunctionName: ''
  };

  const removeNode = (nodeData) => {
    const newTreeData = { ...treeData };
    loopTreeData(treeData, (node) => {
      if (nodeData?.nodeId === node.nodeId) {
        const objectPath = findPath(newTreeData, 'nodeId', node.nodeId);
        const pathArray = formatPath(objectPath);
        unset(newTreeData, pathArray);
      }
    });
    setTreeData({ ...newTreeData });
  };

  const onSubmitModalData = (data) => {
    switch (typeNodeAction) {
      case 'ADD_NEW_NODE_CHILD':
        createNewNode(data);
        break;
      case 'EDIT_NODE':
        editNode(data);
        break;
      default:
        break;
    }
    setIsModalOpen(false);
  };

  const createNewNode = (data) => {
    const newTreeData = { ...treeData };
    const objectPath = findPath(newTreeData, 'nodeId', selectedNode?.nodeId);
    const pathArray = formatPath(objectPath);

    const fatherNodeList = Object.keys(selectedNode.nodes);

    let newNodeId =
      fatherNodeList.length > 0 ? Math.max(...fatherNodeList) + 1 : 0;

    const nodeList = { ...selectedNode.nodes };

    switch (typeNodeAction) {
      case 'ADD_NEW_NODE_CHILD': {
        const newNode = {
          nodeId: uuid(),
          level: selectedNode.level + 1,
          queueId: data.chooseNodeQueue == true ? data.nodeQueue : undefined,
          numericIdentifier: data.numericIdentifier,
          stringIdentifier: data.stringIdentifier,
          possibleAnswers: data.possibleAnswers,
          action: data.action,
          mac: {
            level: selectedNode.level,
            idMac: selectedNode.nodeId
          },
          nodes: {},
          hasVariable: data.hasVariable,
          variables: data.variables,
          conditionSettings: data.conditionSettings,
          chooseNodeQueue: data.chooseNodeQueue,
          nodeQueue: data.nodeQueue,
          hasIntegration: data.hasIntegration,
          params: data.params,
          integrationFunctionName: data.integrationFunctionName
        };

        if (
          data.action.type === 'SUBMENU' ||
          data.action.type === 'SUBMENU_BUTTONS' ||
          data.action.type === 'SEND_AWAIT' ||
          data.action.type === 'CREATE_PROTOCOL' ||
          data.action.type === 'EXECUTE_INTEGRATION'
        ) {
          newNode.nodes[0] = {
            ...defaultNode,
            nodeId: uuid(),
            level: newNode.level + 1,
            mac: {
              level: newNode.level,
              idMac: newNode.nodeId
            }
          };
        } else if (data.action.type === 'CONDITIONAL_CHECK') {
          newNode.nodes[0] = {
            ...defaultNode,
            nodeId: data?.conditionSettings?.else?.id,
            nodes:
              data?.conditionSettings?.else?.type === 'SUBMENU' ||
              data?.conditionSettings?.else?.type === 'SUBMENU_BUTTONS' ||
              data?.conditionSettings?.else?.type === 'SEND_AWAIT' ||
              data?.conditionSettings?.else?.type === 'CREATE_PROTOCOL' ||
              data?.conditionSettings?.else?.type === 'EXECUTE_INTEGRATION'
                ? {
                    0: {
                      ...defaultNode,
                      nodeId: uuid(),
                      level: newNode.level + 2,
                      mac: {
                        level: newNode.level + 1,
                        idMac: data?.conditionSettings?.else?.id
                      }
                    }
                  }
                : {},
            level: newNode.level + 1,
            mac: {
              level: newNode.level,
              idMac: newNode.nodeId
            },
            action: {
              type: data?.conditionSettings?.else?.type,
              message: ''
            }
          };

          data.conditionSettings.conditions.forEach((condition, index) => {
            newNode.nodes[index + 1] = {
              nodeId: condition.id,
              action: {
                type: condition.type,
                message: ''
              },
              chooseNodeQueue: false,
              conditionSettings: {
                conditions: [{ validationString: '', type: '' }],
                else: { validationString: 'else', type: '' }
              },
              nodes:
                condition.type === 'SUBMENU' ||
                condition.type === 'SUBMENU_BUTTONS' ||
                condition.type === 'SEND_AWAIT' ||
                condition.type === 'CREATE_PROTOCOL' ||
                condition.type === 'EXECUTE_INTEGRATION'
                  ? {
                      0: {
                        ...defaultNode,
                        nodeId: uuid(),
                        level: newNode.level + 2,
                        mac: {
                          level: newNode.level + 1,
                          idMac: condition.id
                        }
                      }
                    }
                  : {},
              level: newNode.level + 1,
              mac: {
                level: newNode.level,
                idMac: newNode.nodeId
              },
              numericIdentifier: `${index + 1}`,
              possibleAnswers: {},
              stringIdentifier: condition.validationString,
              hasVariable: false,
              variables: []
            };
          });
        }

        nodeList[newNodeId] = newNode;

        set(newTreeData, pathArray + '.nodes', nodeList);
        break;
      }
      case 'EDIT_NODE':
        data.mac = {
          level: selectedNode.level,
          idMac: selectedNode.nodeId
        };

        Object.keys(selectedNode.nodes).filter((key) => {
          if (selectedNode.nodes[key].nodeId === data.nodeId) {
            newNodeId = key;
          }
        });

        nodeList[newNodeId] = data;

        selectedNode.nodes = nodeList;

        set(newTreeData, pathArray + '.nodes', nodeList);
        break;
      default:
        break;
    }

    setTreeData({ ...newTreeData });
  };

  const editNode = (data) => {
    const newTreeData = { ...treeData };

    if (data.action.type !== 'CONDITIONAL_CHECK') {
      data.conditionSettings = {};
    }

    selectedNode.queueId =
      data.chooseNodeQueue === true ? data.nodeQueue : undefined;

    if (
      selectedNode.nodes &&
      Object.keys(selectedNode.nodes).length === 1 &&
      Object.keys(selectedNode.nodes[0].action).length === 0
    ) {
      delete selectedNode.nodes[0];
    }

    if (
      selectedNode.nodes &&
      Object.keys(selectedNode.nodes).length > Object.keys(data.nodes).length
    ) {
      Object.values(selectedNode.nodes).map((node, index) => {
        Object.values(data.nodes).filter((condition) => {
          if (condition.id !== node.nodeId) {
            delete selectedNode.nodes[index];
          }
        });
      });
    }

    //Update node information
    loopTreeData(newTreeData, (node) => {
      if (
        node.nodeId === selectedNode?.nodeId &&
        node.level === selectedNode.level
      ) {
        node.numericIdentifier = data.numericIdentifier;
        node.stringIdentifier = data.stringIdentifier;
        node.possibleAnswers = data.possibleAnswers;
        node.action = data.action;
        node.hasVariable = data.hasVariable;
        node.variables = data.variables;
        node.conditionSettings = data.conditionSettings;
        node.chooseNodeQueue = data.chooseNodeQueue;
        node.nodeQueue = data.nodeQueue;
        node.hasIntegration = data.hasIntegration;
        node.params = data.params;
        node.integrationFunctionName = data.integrationFunctionName;
      }
    });
    setTreeData({ ...newTreeData });

    if (
      (data.action.type === 'SUBMENU' ||
        data.action.type === 'SUBMENU_BUTTONS' ||
        data.action.type === 'SEND_AWAIT' ||
        data.action.type === 'CREATE_PROTOCOL' ||
        data.action.type === 'EXECUTE_INTEGRATION') &&
      !data.nodes[0]
    ) {
      createNewNode({
        ...defaultNode,
        nodeId: uuid()
      });
    }

    if (data.action.type === 'CONDITIONAL_CHECK') {
      // Create default node from else
      let nodeToCreate = {
        ...defaultNode,
        nodeId: data?.conditionSettings?.else?.id,
        nodes:
          data?.conditionSettings?.else?.type === 'SUBMENU' ||
          data?.conditionSettings?.else?.type === 'SUBMENU_BUTTONS' ||
          data?.conditionSettings?.else?.type === 'SEND_AWAIT' ||
          data?.conditionSettings?.else?.type === 'CREATE_PROTOCOL' ||
          data?.conditionSettings?.else?.type === 'EXECUTE_INTEGRATION'
            ? {
                0: {
                  ...defaultNode,
                  nodeId: uuid(),
                  level: selectedNode.level + 2,
                  mac: {
                    level: selectedNode.level + 1,
                    idMac: data?.conditionSettings?.else?.id
                  }
                }
              }
            : {},
        mac: {
          level: selectedNode.level,
          idMac: selectedNode.nodeId
        },
        action: {
          type: data?.conditionSettings?.else?.type,
          message: ''
        }
      };

      if (data.nodes !== undefined && Object.keys(data.nodes).length > 0) {
        let elseNode;
        let elseNodeIndex;
        for (let i = 0; i < Object.keys(data.nodes).length; i++) {
          if (data.nodes[i]?.isDefault && data?.conditionSettings?.else?.id) {
            elseNodeIndex = i;
            elseNode = data.nodes[i];
            break;
          }
        }

        if (elseNode) {
          nodeToCreate = {
            ...data.nodes[elseNodeIndex],
            mac: {
              level: selectedNode.level,
              idMac: selectedNode.nodeId
            },
            action: {
              ...data?.nodes[elseNodeIndex].action,
              type: data?.conditionSettings?.else?.type
            }
          };
          if (
            selectedNode?.conditionSettings?.else?.type !=
            data?.conditionSettings?.else?.type
          ) {
            nodeToCreate.nodes =
              data?.conditionSettings?.else?.type === 'SUBMENU' ||
              data?.conditionSettings?.else?.type === 'SUBMENU_BUTTONS' ||
              data?.conditionSettings?.else?.type === 'SEND_AWAIT' ||
              data?.conditionSettings?.else?.type === 'CREATE_PROTOCOL' ||
              data?.conditionSettings?.else?.type === 'EXECUTE_INTEGRATION'
                ? {
                    0: {
                      ...defaultNode,
                      nodeId: uuid(),
                      level: selectedNode.level + 2,
                      mac: {
                        level: selectedNode.level + 1,
                        idMac: data?.conditionSettings?.else?.id
                      }
                    }
                  }
                : {};
          }
        }
      }

      createNewNode(nodeToCreate);

      // Create nodes from conditions
      const level = selectedNode.level;
      data.conditionSettings.conditions.forEach((condition, index) => {
        let nodeDataToInsert = {
          nodeId: condition.id,
          action: {
            type: condition.type,
            message: ''
          },
          chooseNodeQueue: false,
          conditionSettings: {
            conditions: [{ validationString: '', type: '' }],
            else: { validationString: 'else', type: '' }
          },
          nodes:
            condition.type === 'SUBMENU' ||
            condition.type === 'SUBMENU_BUTTONS' ||
            condition.type === 'SEND_AWAIT' ||
            condition.type === 'CREATE_PROTOCOL' ||
            condition.type === 'EXECUTE_INTEGRATION'
              ? {
                  0: {
                    ...defaultNode,
                    nodeId: uuid(),
                    level: selectedNode.level + 2,
                    mac: {
                      level: selectedNode.level + 1,
                      idMac: data?.conditionSettings?.else?.id
                    }
                  }
                }
              : {},
          level: level + 1,
          mac: {
            level: selectedNode.level,
            idMac: selectedNode.nodeId
          },
          numericIdentifier: `${index + 1}`,
          possibleAnswers: {},
          stringIdentifier: condition.validationString,
          hasVariable: false,
          variables: [],
          hasIntegration: false,
          params: [],
          integrationFunctionName: ''
        };

        Object.keys(data.nodes).filter((key) => {
          if (data.nodes[key].nodeId === condition.id) {
            nodeDataToInsert = {
              ...data.nodes[key],
              stringIdentifier: condition.validationString,
              action: {
                ...data.nodes[key].action,
                type: condition.type
              }
            };
          }
        });
        createNewNode(nodeDataToInsert);
      });
    }

    setTreeData({ ...newTreeData });
  };

  const validateTreeData = () => {
    let error = undefined;

    loopTreeData(treeData, (node) => {
      if (validateNode(node) === false) {
        error = 'Preencha os nós destacados em vermelho';
      } else if (Object.keys(node.action).length === 0) {
        error = 'Ação padrão não configurada em todos os níveis';
      }
    });
    return error;
  };

  const submitDataToBackend = async (data, isUpdate, id) => {
    const queueId = data.queue_id?.length == 0 ? undefined : data.queue_id;
    const attendantLogin =
      data.attendant_login?.length == 0 ? undefined : data.attendant_login;

    const dataToSend = {
      name: data.treeName,
      dialog: treeData,
      queue_id: queueId,
      attendant_login: attendantLogin
    };

    if (validateTreeData() === undefined) {
      if (isUpdate) {
        FlexChatIntegration.putDialogTree(id, dataToSend)
          .then(() => {
            toast.success('Árvore de diálogo atualizada com sucesso');
            history.push('/admin/ChatDialogTree');
          })
          .catch((err) => {
            toast.error(
              err.response.data.message || 'Erro ao atualizar árvore de diálogo'
            );
          });
      } else {
        FlexChatIntegration.postDialogTree(dataToSend)
          .then(() => {
            toast.success('Árvore de diálogo criada com sucesso');
            history.push('/admin/ChatDialogTree');
          })
          .catch((err) => {
            toast.error(
              err.response.data.message || 'Erro ao criar árvore de diálogo'
            );
          });
      }
    } else {
      toast.error(validateTreeData());
    }
  };

  const openModal = (nodeData, type) => {
    if (nodeData) {
      setSelectedNode(nodeData);
      setTypeNodeAction(type);
      setIsModalOpen(true);
    }
  };

  const resetTree = useCallback(() => {
    setTreeData({
      0: {
        nodeId: uuid(),
        level: 1,
        nodeQueue: undefined,
        mac: {
          level: null,
          idMac: null
        },
        action: {},
        nodes: {},
        isDefault: true,
        hasVariable: false,
        variables: [],
        hasIntegration: false,
        params: [],
        integrationFunctionName: ''
      }
    });

    setSelectedNode({});

    setIsModalOpen(false);

    setTypeNodeAction('');
  }, []);

  useEffect(() => {
    if (!isModalOpen) setSelectedNode({});
  }, [isModalOpen]);

  useEffect(() => {
    FlexChatIntegration.getActionDialogTree()
      .then((response) => {
        setNodeActions(response.data);
      })
      .catch(() => {
        toast.error('Ocorreu um erro ao carregar as ações do nó');
      });
  }, []);

  return (
    <DialogTreeContext.Provider
      value={{
        removeNode,
        selectedNode,
        treeData,
        setTreeData,
        isModalOpen,
        setIsModalOpen,
        openModal,
        onSubmitModalData,
        typeNodeAction,
        actualLevelAvailableLevels,
        submitDataToBackend,
        resetTree,
        setAvailableActions,
        setAvailableQueues,
        availableActions,
        availableQueues,
        nodeActions,
        linkedNodeId,
        setLinkedNodeId
      }}
    >
      {children}
    </DialogTreeContext.Provider>
  );
}

export function useDialogTree() {
  const dialogContext = useContext(DialogTreeContext);
  return dialogContext;
}
